(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
function disableScroll() {

    /*window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);*/
}

function enableScroll() {

    /*window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);*/
}

document.addEventListener('DOMContentLoaded', e => {

    chooseUnitsPR();
    chooseUnitsRS();

     // FUNCTION TO INIT CHOOSE LOCATION

     function chooseUnitsPR(){
        const unitsSelectPR = document.getElementById('choose-units-pr');
  
     if(unitsSelectPR) {
       const unitsOptionsPR = unitsSelectPR.options[unitsSelectPR.selectedIndex];
       const optionSelectedPR = unitsOptionsPR.value;
       const unitsContainerSelectedPR = document.querySelectorAll('.js-choose-units-pr');
   
       unitsContainerSelectedPR.forEach((unit) => {
         const dataUnit = unit.getAttribute("data-unit");
   
         if(dataUnit === optionSelectedPR) {
           unit.classList.add('d-flex');
           unit.classList.remove('d-none');
         } else {
           unit.classList.add('d-none');
           unit.classList.remove('d-flex');
         }
       });
   
       unitsSelectPR.addEventListener('change', () => {
         chooseUnitsPR();
       });
     }
     }
     

     function chooseUnitsRS(){
        const unitsSelectRS = document.getElementById('choose-units-rs');
  
     if(unitsSelectRS) {
       const unitsOptionsRS = unitsSelectRS.options[unitsSelectRS.selectedIndex];
       const optionSelectedRS = unitsOptionsRS.value;
       const unitsContainerSelectedRS = document.querySelectorAll('.js-choose-units-rs');
   
       unitsContainerSelectedRS.forEach((unit) => {
         const dataUnit = unit.getAttribute("data-unit");
   
         if(dataUnit === optionSelectedRS) {
           unit.classList.add('d-flex');
           unit.classList.remove('d-none');
         } else {
           unit.classList.add('d-none');
           unit.classList.remove('d-flex');
         }
       });
   
       unitsSelectRS.addEventListener('change', () => {
         chooseUnitsRS();
       });
     }
     }
  
    /*
    * SWIPER SLIDERS
    * COMPONENT - HEADER
    * */
    const phoneSlider = new Swiper('.swiper-phones', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-phone-next',
            prevEl: '.swiper-button-phone-prev',
        },
        observer: true,
        observeParents: true,
        watchOverflow: true
    });
    const bannerSlider = new Swiper('.swiper-banners', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next-banners',
            prevEl: '.swiper-button-prev-banners',
        },
        pagination: {
            el: '.swiper-pagination-banners',
            clickable: true
        },
        watchOverflow: true
    });

    const carsSlider = new Swiper('.swiper-promotion-cars', {
        spaceBetween: 30,
        slidesPerView: 1,
        /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/
        observer: true,
        observeParents: true,
        centerInsufficientSlides: true,
        navigation: {
            nextEl: '.swiper-button-next-promotion',
            prevEl: '.swiper-button-prev-promotion',
        },
        breakpoints: {
            992: {
                spaceBetween: 45,
                slidesPerView: 3,
            }
        },
        pagination: {
            el: '.swiper-pagination-promotion',
            clickable: true
        },
        watchOverflow: true
    });
    const callsSlider = new Swiper('.swiper-banners-call', {
        spaceBetween: 0,
        slidesPerView: 1,
        /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next-call',
            prevEl: '.swiper-button-prev-call',
        },
        breakpoints: {
            1600:{
                spaceBetween: 45,
                slidesPerView: 4,
            },

            1440: {
                spaceBetween: 45,
                slidesPerView: 4,
            },

            1366: {
                spaceBetween: 45,
                slidesPerView: 3,
            },

            1024: {
                spaceBetween: 45,
                slidesPerView: 2,
            }
        },
        /*pagination: {
            el: '.swiper-pagination',
            clickable: true
        },*/
        watchOverflow: true
    });
    const megamenuSlider = new Swiper('.swiper-megamenu', {
        spaceBetween: 0,
        slidesPerView: 1,
        /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next-megamenu',
            prevEl: '.swiper-button-prev-megamenu',
        },
        breakpoints: {
            992: {
                spaceBetween: 30,
                slidesPerView: 4,
            }
        },
        pagination: {
            el: '.swiper-pagination-megamenu',
            clickable: true
        },
        watchOverflow: true
    });
    /**
     * PAGE /NOVO/:SLUG  - VEICULO NOVO INTERNO
     * */
    const singleSliderDetails = new Swiper('.details-img-slider', {
        spaceBetween: 0,
        slidesPerView: 1,
        /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next-details',
            prevEl: '.swiper-button-prev-details',
        },
        breakpoints: {
            992: {
                spaceBetween: 30,
                slidesPerView: 4,
            }
        },
        pagination: {
            el: '.swiper-pagination-details',
            clickable: true
        },
        watchOverflow: true
    });
    const singleSliderCarSelectors = new Swiper('.selector-color-slider', {
        spaceBetween: 30,
        slidesPerView: 1,
        /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next-color-slider',
            prevEl: '.swiper-button-prev-color-slider',
        },
        breakpoints: {
            992: {
                spaceBetween: 30,
                slidesPerView: 4,
            }
        },
        watchOverflow: true
    });
    /*
    *PAGE /NOVOS
    * */
    const userCarsSlider = new Swiper(".car-img-slider",{
        direction:"horizontal",
        loop:true,
        observer:true,
        observeParents:true,
        navigation:{
            nextEl:".swiper-button-next-cardsvehicles",
            prevEl:".swiper-button-prev-cardsvehicles",
            clickable:true
        }
    });
    /*
    *PAGE /PECAS
    * */
    const PiecesPerRow = new Swiper('.pieces-per-row', {
        slidesPerView: 1,
        slidesPerColumn: 2,
        slidesPerGroup: 1,
        spaceBetween: 20,
        slidesPerColumnFill: 'row',
        direction: 'horizontal',
        navigation:{
            nextEl:".swiper-button-next-pieces",
            prevEl:".swiper-button-prev-pieces",
            clickable:true
        },
        pagination: {
          el: '.swiper-pagination-pieces',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
          },
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
                slidesPerColumn: 2,
                slidesPerGroup:4,
                spaceBetween: 20,
            }
        },
    });
    /*
    *PAGE /ASSISTENCIA
    * */
    const supportTabs = new Swiper('.supportTabs', {
        spaceBetween: 0,
        slidesPerView: 3,
        loopedSlides: 3,
        loop: false,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        cssMode: true,
    });
    const SupportContents = new Swiper('.supportContents', {
        spaceBetween: 30,
        loop: false,
        loopedSlides: 3, //looped slides should be the same
        thumbs: {
          swiper: supportTabs,
        },
    });

    /*
    * PAGE /A-STRADA
    * */
    const storeSlider = new Swiper('.swiper-store-slider', {
        spaceBetween: 30,
        slidesPerView: 1,
        /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next-store',
            prevEl: '.swiper-button-prev-store',
        },
        breakpoints: {
            992: {
                spaceBetween: 30,
                slidesPerView: 4,
            }
        },/*
        pagination: {
            el: '.swiper-pagination-store',
            clickable: true,
        },*/
        watchOverflow: true
    });
    /* *
    *PAGE /VENDAS
    * */
    const sellTabs = new Swiper('.sellTabs', {
        spaceBetween: 0,
        slidesPerView: 1,
        loopedSlides: 1,
        loop: false,
        freeMode: false,
        mousewheelSensitivity: 0,
        mousewheelReleaseOnEdges: true,
        navigation:{
            nextEl:".swiper-button-next-sell",
            prevEl:".swiper-button-prev-sell",
            clickable:true
        },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        cssMode: true,
        breakpoints: {
            992: {
                spaceBetween: 0,
                slidesPerView: 8,
                loopedSlides: 8,

            }
        },
    });
    const sellContents = new Swiper('.sellContents', {
        spaceBetween: 30,
        loop: false,
        loopedSlides: 8, //looped slides should be the same
        mousewheelSensitivity: 0,
        mousewheelReleaseOnEdges: true,
        thumbs: {
            swiper: sellTabs,
        },

        navigation:{
            nextEl:".swiper-button-next-sell",
            prevEl:".swiper-button-prev-sell",
            clickable:true
        }
    });

    const swiperLancamento = new Swiper('.swiper-lancamento', {
        slidesPerView: "auto",
        spaceBetween: 20,
        grabCursor: true,
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        },
        breakpoints: {
        900: {
            slidesPerView: "auto",
            spaceBetween: 30
        }
        }
    });

    const galleryPreviewSwiper = new Swiper('.gallery-preview-swiper', {
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          900: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        }
      });
    const SetSlideOnClick = (() => {

        let checkIfVendas = window.location.pathname;
        let getHash = window.location.hash;

        if(checkIfVendas.indexOf('/vendas') >= 0){
            if(getHash.indexOf('#slide') >= 0){

                //if(window.innerWidth > 768){

                    let getNumber = getHash.replace('#slide', '');
                    let sellContent = document.querySelector('.sellContents');
                    window.scrollTo(0, sellContent.offsetHeight * 1.5);
                    sellTabs.slideTo(getNumber);
                    sellContents.slideTo(getNumber);

                /*} else if(window.innerWidth <= 768){

                    let getNumber = getHash.replace('#slide', '');
                    let sellContent = document.querySelector('.sellContents');
                    window.scrollTo(0, sellContent.offsetHeight / 1.5);
                    sellTabs.slideTo(getNumber);
                    sellContents.slideTo(getNumber);

                }*/

            }

        }

    })();
    /* ADD CLASS TO ANIMATE DROPDOWN */
    const dropdownMenu = ((ev) => {
        let drop = document.querySelectorAll('.drop');
        let dropdwn = document.querySelectorAll('.dropdown-menu');
        let chevron = document.querySelectorAll('.drop > button > i');

            //CHECK IF HAS ANY DROPDOWN AND APPLY DROP EFFECT
            for(let dp = 0; dp < drop.length; dp++){

                drop[dp].addEventListener('click', (ev) => {

                    drop[dp].dataset.active = 'active';
                    chevron[dp].classList.toggle('negative');
                    dropdwn[dp].classList.toggle('active-drop');

                    if(drop[0].dataset.active != undefined){
                        if(drop[dp+1].dataset.active != undefined){
                            if(drop[dp+1].dataset.active.indexOf('active') >= 0){
                                drop[dp+1].dataset.active = 'inactive';
                                chevron[dp+1].classList.remove('negative');
                                dropdwn[dp+1].classList.remove('active-drop');
                            }
                        }
                    } else {
                        if(drop[dp-1].dataset.active != undefined){
                            if(drop[dp-1].dataset.active.indexOf('active') >= 0){
                                drop[dp-1].dataset.active = 'inactive';
                                chevron[dp-1].classList.remove('negative');
                                dropdwn[dp-1].classList.remove('active-drop');
                            }
                        } else if(drop[dp+1].dataset.active != undefined){
                            if(drop[dp+1].dataset.active.indexOf('active') >= 0){
                                drop[dp+1].dataset.active = 'inactive';
                                chevron[dp+1].classList.remove('negative');
                                dropdwn[dp+1].classList.remove('active-drop');
                            }
                        }
                    }

                });

                dropdwn[dp].addEventListener('click', (ev) => {
                    ev.stopPropagation();
                });

            }


    })();

    /* LOAD FIXED MENU */
    const FixedMenuCaller = (() => {

        let scrol = window.scrollY;
        let hf = document.querySelector('.header-fixed');
        let hfm = document.querySelector('.header-m-fixed');
        let bannerC = document.querySelector('.banner-container');
        let formMain = document.querySelector('.form-main');
        let ff = document.querySelector('.footer-fixed');

        if(scrol >= 100){
            hf.classList.add('active');
            ff.classList.add('active');
            hfm.classList.add('active');

            if(bannerC != undefined){
                formMain.classList.add('hide');
            }

        } else {
            hf.classList.remove('active');
            ff.classList.remove('active');
            hfm.classList.remove('active');

            if(bannerC != undefined){
                formMain.classList.remove('hide');
            }
        }

        window.onscroll = (() => {
            let scrol = window.scrollY;
            let hf = document.querySelector('.header-fixed');
            let ff = document.querySelector('.footer-fixed');
            let hfm = document.querySelector('.header-m-fixed');
            let bannerC = document.querySelector('.banner-container');
            let formMain = document.querySelector('.form-main');

            if (window.innerWidth > 992) {
                if(scrol >= 600){
                    hf.classList.add('active');
                    ff.classList.add('active');
                    hfm.classList.add('active');

                    if(bannerC != undefined){
                        formMain.classList.add('hide');
                    }

                } else {
                    hf.classList.remove('active');
                    ff.classList.remove('active');
                    hfm.classList.remove('active');

                    if(bannerC != undefined){
                        formMain.classList.remove('hide');
                    }
                }
            } else {
                if(scrol >= 200){
                    hf.classList.add('active');
                    hfm.classList.add('active');

                    if(bannerC != undefined){
                        formMain.classList.add('hide');
                    }

                } else {
                    hf.classList.remove('active');
                    hfm.classList.remove('active');

                    if(bannerC != undefined){
                        formMain.classList.remove('hide');
                    }
                }
            }


        })
    })();


    const FixedFormCaller = (() => {
        const btnFormFixed = document.querySelectorAll('.btn-form-fixed');
        const CloseText = document.querySelector('.close-text');
        const OpenText = document.querySelector('.open-text');
        const mainForm = document.querySelectorAll('.form-main');
        const FixedForm = document.querySelector('.form-controller-fixed');
        const closeBtn = document.querySelector('.btn-form-close');

        for (let b = 0; b < btnFormFixed.length; b++) {
            btnFormFixed[b].addEventListener('click', () => {
                for (let i = 0; i < mainForm.length; i++) {
                    $(mainForm[i]).hasClass('new_veichle fixed') ? $(mainForm[i]).hide() : $(mainForm[i]).show();
                    mainForm[i].classList.toggle('fixed');
                    $('.header-fixed').addClass('active');
                }

                if (window.innerWidth > 768) {
                    if (CloseText !== undefined) {
                        if (CloseText.classList.contains('hide')) {
                            CloseText.classList.remove('hide');
                            FixedForm.classList.remove('hide');
                            OpenText.classList.add('hide');
                        } else {
                            CloseText.classList.add('hide');
                            if (OpenText.classList.contains('hide')) {
                                OpenText.classList.remove('hide');
                                FixedForm.classList.add('hide');
                            }
                        }
                    }
                } else if (window.innerWidth <= 768) {
                    FixedForm.classList.toggle('hide');
                }

                overlayded();
            });
        }

        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            FixedForm.classList.add('hide');

            for (let i = 0; i < mainForm.length; i++) {
                mainForm[i].classList.remove('fixed');
            }

            overlayded();
        });
    })();

    const SelectColorInSingleCar = (() => {
        const bubbleSelectors = document.querySelectorAll('.color-selector');
        const carSelector = document.querySelectorAll('.carSelector');

        for (let i = 0; i < bubbleSelectors.length; i++) {
            const dataCar = bubbleSelectors[i].children[0].dataset.car;
            const dataSelectCar = bubbleSelectors[i].children[0].dataset.selectcar;
            const selectColor = bubbleSelectors[i].children[0].dataset.color;
            const changeColor = bubbleSelectors[i];

            changeColor.style.background = selectColor;
            bubbleSelectors[i].addEventListener('click', () => {
                carSelector[dataSelectCar].children[0].src = dataCar;
            });
        }
    })();

    const destructForm = (() => {
        const checkBanner = document.querySelector('.banner-container');
        const formFloat = document.querySelector('.form-controller-fixed');
        if (window.innerWidth >= 769) {
            if (checkBanner !== undefined) {
                formFloat.innerHTML = '';
            }
        }
    })();

});

/* FUNCTIONS */

/* SHOW AND HIDE FIXED MENU */





/* SESSION JQUERY */

// Modal Test Drive
$('.btnTestDrive').click(function() {
    $('[name=modelo]').val($(this).data("car")).change();
    $('#mTestDrive').modal('show');
})


// Modal Unit
$('.btnUnit').click(function() {
    //$('[name=modelo]').val($(this).data("car")).change();
    $('#modal-units').modal('show');
})


// Modal Unit
$('.btnLigue').click(function() {
    //$('[name=modelo]').val($(this).data("car")).change();
    $('#modal-call').modal('show');
})


// Botão Carro Novo
$('.btnWish').click(function() {
    $('[name=modelo]').val($(this).data("car")).change();
    $('.btn-form-fixed').eq(0).trigger('click');
});

// Botão Promoção
$('.btnPromo').click(function() {
    //console.log($(this).data("car"))
    $('[name=modelo]').val($(this).data("car")).change();
    $('#mPromotion').modal('show');
});


// Botão Indique um amigo
$('.btnFriend').click(function() {
    $('#mFriend').modal('show');
});


// Botão Peça já o seu
$('.peca-o-seu').click(function() {
    $('[name=modelo]').val($(this).data("car")).change();
    $('.btn-form-fixed').eq(0).trigger('click');
});


//  Formata data de postagem do Blog
$(".dateFormat").replaceWith(function(){
    let text = moment($(this).text()).locale('pt').format('DD [de] MMMM [de] YYYY').toUpperCase();
    return text;
})

// DARK SIDE OF FORCE

const scrollToEl = () => {
    $('html,body').animate({
        scrollTop: $(`.scroll-target`).offset().top - 60
    }, 100)
}

},{}]},{},[1])